import React, { useState, useEffect } from 'react'
import Button from '../../atoms/button/button'

import imgLogoTop from '../../../assets/images/top-section/logo_top.png'
import imgIconLogo from '../../../assets/images/top-section/icon_lupa.png'

import {
  datesActivity,
  topNumber,
  gameId,
} from '../../../constants/activity-constants'

import { siteUrl } from '../../../shared/utils/siteUrl'
import gameServices from '../../../services/game-service'

import getUrlIdRegister from '../../../utils/getUrlIdRegister'
import userSessionStorage from '../../../utils/userSessionStorage'

import './top-section.scss'
import { navigate } from 'gatsby'
import { useContext } from 'react'
import { Context } from '../../../context/app-context'
import { pushEventData } from '../../../utils/pushEventDataLayer';


const italilatam = process.env.LOCALE === 'es-AR' || process.env.LOCALE === 'es-PY';

const IniciarSesionBtn = ({ isMobile }) => {
  const { dispatch } = useContext(Context)
  return (<Button onClick={() => {

    pushEventData({
      event: 'Inicio sesión',
      action: "click juego",
      label: 'Iniciar sesión'
    });
    dispatch({
      type: 'set-modal',
      modalActive: {
        type: 'login',
        props: {
          close: () => {
            dispatch({ type: 'clear-modal' })
          },
          handleSuccess: () => {
            window.location.reload()
          },
          mobile: isMobile,
        },
      },
    })
  }}>Iniciar sesión</Button>);
}
const TopSection = ({ isMobile }) => {
  const session = new userSessionStorage()

  const [topWinners, setTopWinners] = useState([])
  const [userData, setUserData] = useState({})


  useEffect(() => {
    getTop()
  }, [])

  const getTop = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
          Authorization: tokenId,
        }
        : undefined,
    }
    gameServices.getTopPagination(gameId, topNumber, 0, config).then(res => {
      if (res.status === 200) {
        setUserData(res.data)
        setTopWinners(res.data.topGame)
      }
    })
  }

  const formatNumber = number => {
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return 0
  }

  return (
    <div id="top-jugadoras" className="f-top-section-container">
      <div className="f-top-section-container__wrapper">
        <section className="f-top-section-container__left">
          <img src={imgLogoTop} alt="top jugadoras" />
          <img src={imgIconLogo} alt="imagen de una lupa" />
          <p>
            <b> {italilatam ? '¿Sos' : '¿Eres'} la mejor encontrando palabras? </b>¡Entonces {italilatam ? 'buscá' : 'busca'} tu
            nombre entre los mejores puntajes!
          </p>
          <p>
            Si no estás en nuestro top {topNumber} ¡{italilatam ? 'seguí' : 'sigue'} jugando! {italilatam ? 'tenés' : 'tienes'} hasta
            el {datesActivity.dateEndGame} para alcanzar los mejores puntajes.
          </p>
        </section>
        <section className="f-top-section-container__right">
          <div className="f-top-section-container__right__top">
            {session.getUserInfo() ? (
              <>
                <div className="f-top-section-container__right__top__container">
                  <h1 className="f-top-section-container__right__top__nameUserLogin">
                    ¡Hola {session.getUserInfo().name.split(' ')[0]}!
                  </h1>
                  <div className="f-top-section-container__right__top__leftLogin">
                    <div className="f-top-section-container__right__boxContainer smallBox">
                      <h2>Tus puntos</h2>
                      <span>
                        {userData.point ? formatNumber(userData.point) : 0}
                      </span>
                    </div>
                    <div className="f-top-section-container__right__boxContainer smallBox ml-10">
                      <h2>Tu Puesto</h2>
                      <span>{userData.position}</span>
                    </div>
                  </div>
                </div>
                <div className="f-top-section-container__right__top__rightLogin">
                  <p>
                    <b>¡Mejora tu puntaje jugando </b>
                    las veces que quieras!
                  </p>
                  <Button onClick={() => {
                    pushEventData({
                      event: 'Quiero jugar',
                      action: "click juego",
                      label: 'Jugar'
                    });
                    navigate("/game")
                  }}>Jugar</Button>
                </div>
              </>
            ) : (
              <>
                <p>
                  <b>
                    Inicia sesión para conocer tu puntaje y tu posición dentro
                    del top de jugadoras
                  </b>
                  <br /> <br />
                  {isMobile && [<IniciarSesionBtn isMobile={isMobile} />, <br />, <br />]}

                  Si aún no formas parte de NosotrasOnline{' '}
                  {isMobile && <br />}
                  <a
                    href='#'
                    onClick={() => {
                      pushEventData({
                        event: 'Enlaces',
                        category: "link",
                        action: "click",
                        label: 'REGÍSTRATE AQUÍ.'
                      });
                      window.open(siteUrl + getUrlIdRegister(), '_blank')
                    }}
                  >
                    REGÍSTRATE {italilatam ? 'ACÁ' : 'AQUÍ'}.
                  </a>
                </p>
                {!isMobile && <IniciarSesionBtn isMobile={isMobile} />}
              </>
            )}
          </div>
          <div className="f-top-section-container__right__bot">
            <div className="f-top-section-container__right__boxContainer">
              <h2>Las mejores jugadoras están {italilatam ? 'acá' : 'aquí'}</h2>
              <div className="f-top-section-container__right__boxContainer__contentBox">
                {!isMobile && (
                  <span className="f-top-section-container__right__boxContainer__contentBox__headerList">
                    <h3>NOMBRE</h3>
                    <h3>CORREO</h3>
                  </span>
                )}
                <ol>
                  {topWinners.map((item, index) => {
                    return (
                      <li key={'top' + index}>
                        <span>{index + 1}</span>
                        <p>{item.name}</p>
                        <p>{item.email}</p>
                      </li>
                    )
                  })}
                </ol>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default TopSection
